import { FunctionComponent } from 'react';

import {
    Box,
    Divider,
    MenuItem,
    MenuList,
    Popover,
    PopoverProps,
    Typography,
} from '@mui/material';
import { useAuthentication } from '@/hooks/useAuthentication';

type AccountPopover = {
    open: boolean;
    anchorEl: PopoverProps['anchorEl'];
    onClose?: () => void;
};

export const AccountPopover: FunctionComponent<AccountPopover> = ({
    anchorEl,
    onClose,
    open,
}) => {
    const { liftOperatorData, logout } = useAuthentication();

    const handleSignOut = () => {
        onClose?.();
        logout();
    };

    return (
        <Popover
            anchorEl={anchorEl}
            anchorOrigin={{
                horizontal: 'left',
                vertical: 'bottom',
            }}
            onClose={onClose}
            open={open}
            PaperProps={{ sx: { width: 200 } }}
        >
            <Box
                sx={{
                    py: 1.5,
                    px: 2,
                }}
            >
                <Typography variant='overline'>Account</Typography>
                <Typography color='text.secondary' variant='body2'>
                    {liftOperatorData?.skiOperator}
                </Typography>
            </Box>
            <Divider />
            <MenuList
                disablePadding
                dense
                sx={{
                    p: '8px',
                    '& > *': {
                        borderRadius: 1,
                    },
                }}
            >
                <MenuItem onClick={handleSignOut}>Abmelden</MenuItem>
            </MenuList>
        </Popover>
    );
};
